<template>
  <slot name="footer"></slot>
</template>